module.exports = __webpack_public_path__ + "static/footer-mobile-71813b0f4db42ddaa6ff998c9e5ddab0.png";